import { ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const globalSettingsIssuesTypesScreenSchemesEntityRoute: InvariantRoute = {
	name: ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY,
	path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa',
};
